const SearchOverlayToggler = () => {

	document.querySelector('#search-overlay-toggler').addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.toggle('js-search-overlay-revealed');

		if(document.body.classList.contains('js-search-overlay-revealed')) {
			document.querySelector('#search-input').focus();
		}
	});

	document.querySelector('#search-overlay-close').addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.remove('js-search-overlay-revealed');
	});
};

export default SearchOverlayToggler;